/** Checkout error codes owned by this project (not payment-provider API codes). */
export const CHECKOUT_ERROR_CODES = Object.freeze({
  INVENTORY_UNAVAILABLE: 'CHECKOUT_INVENTORY_UNAVAILABLE',
});

/** Available checkout payment providers. */
export const PAYMENT_PROVIDER = Object.freeze({
  CREDIT_CARD: 'cc',
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
});
